import React, { createContext, useContext, useState, useEffect } from 'react'

import ContextCurrentLocale from '../components/ContextCurrentLocale'
import AccountForm from '../components/IndexPresentationComponent/IndexPresentationComponent'
import { ACCENT_COLOR } from '../server-parameters';
import { ACCENT_TEXT_COLOR } from '../server-parameters'

declare global {
  interface Window {
    iFrameResizer: any
    parentIFrame: any
  }
}

const QueryContext = createContext<string | undefined>(undefined)

export const useQueryContext = () => {
  const query = useContext(QueryContext)
  if (query === undefined) {
    throw new Error(
      'To use the url query context you must wrap component with the QueryContextProvider'
    )
  }
  return query
}

export default function IndexPage() {
  const [query, setQuery] = useState('');

  useEffect(() => {
    if (typeof window !== 'undefined') {
      setQuery(window.location.search);

      const handleLocationChange = () => {
        setQuery(window.location.search);
      };

      window.addEventListener('popstate', handleLocationChange);

      return () => {
        window.removeEventListener('popstate', handleLocationChange);
      };
    }
  }, []);

  return (
    <QueryContext.Provider value={query}>
        <ContextCurrentLocale.Provider value="rus">
        <style>{`:root { --accent-color: ${ACCENT_COLOR}; --accent-text-color: ${ACCENT_TEXT_COLOR} }`}</style>
          <AccountForm />
        </ContextCurrentLocale.Provider>
    </QueryContext.Provider>
  )
}
